export enum OfferHistorySortTypeEnums {
    USER = 'user',
    TYPE_NAME = 'type_name',
    OFFER_DATE = "offerDate",
    OFFER_VALIDITY_DATE = "offerValidityDate"
  }
